import React from 'react'

import { SightseeingAndTourBookingApp } from '@components/cases/SightseeingAndTourBookingApp'
import { CustomHead } from '@ui/sections/CustomHead'

export default function SightseeingAndTourBookingAppPage() {
  return (
    <>
      <CustomHead
        title="Trave and hospitality cross-platform app development - Modsen"
        description="Take a glimpse behind the scenes of online tour booking app development at Modsen. Get a detailed overview of the process and check out the results of our dedicated work."
        imagePath="/images/custom-head/custom-head-sightseeing-and-tour-booking-app.webp"
      />
      <SightseeingAndTourBookingApp />
    </>
  )
}
